import React, { useCallback, useState } from "react";
import { ASSETS } from "../../../utils/config";
import {
  FormControl,
  Select,
  Typography,
  MenuItem,
  TextField,
} from "@mui/material";
import "../styles.css";
import { useFormikContext } from "formik";
import { InputErrorSpan } from "../../inputs.styled";
import { socialPlatforms } from "../BusinessBoxHelpers";
import CloseIcon from "@mui/icons-material/Close";

const AddLinksForm = ({ form, push, remove }) => {
  const { setFieldValue, errors, touched, handleBlur, setFieldTouched } =
    useFormikContext();

  const [innerValue, setInnerValue] = useState("");

  const handleLinkChange = (index, field, value) => {
    setFieldValue(`business_link.${index}.${field}`, value);
    field === "platform" && setInnerValue(value);
  };

  // const handleLinkRemove = (link) => {
  //   var temp = [];
  //   if (link.id) {
  //     temp = form.values.business_link.filter((item) => link.id !== item.id);
  //   } else {
  //     temp = form.values.business_link.filter(
  //       (item) => link.platform !== item.platform
  //     );
  //   }
  //   setFieldValue(`business_link`, temp);
  // };
  const handleAddLink = () => {
    // const id = Math.floor(Date.now() + Math.random());
    push({
      // id,
      platform: "",
      link: "",
    });
  };

  const existingPlatforms = form.values.business_link.map(
    (link) => link.platform
  );

  const handleRenderValue = (value) => {
    const selectedValue = value || innerValue;

    const selectedOption = socialPlatforms.find(
      (item) => item["name"] == selectedValue
    );
    console.log(selectedOption, "SOO");
    return selectedOption ? (
      <>
        <img
          alt="logo"
          src={selectedOption["icon"]}
          style={{
            height: "12px ",
            width: selectedOption["width"],
            // marginLeft: "-7px ",
            marginRight: "6px",
            marginTop: "-2px ",
          }}
        />
        {selectedOption["name"]}
      </>
    ) : (
      "Select Platform"
    );
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography
          variant="h6"
          style={{
            marginBottom: "6px",
            fontSize: "10px",
            fontFamily: "DM Sans",
          }}
        >
          Add Social Links
        </Typography>
        <img
          onClick={handleAddLink}
          src={ASSETS.addLink}
          alt="add"
          style={{ height: "20px", width: "20px", cursor: "pointer" }}
        />
      </div>

      {form.values.business_link.map((link, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
            // paddingRight: "30px",
            gap: "10px",
          }}
        >
          <FormControl
            variant="outlined"
            className="noBorder"
            style={{
              marginRight: "8px ",
              width: "100% ",
              height: "20px ",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Select
                name={`business_link.${index}.platform`}
                onBlur={handleBlur}
                style={{
                  height: "20px ",
                  fontSize: "8px",
                  border: "none ", // This will remove the border
                  outline: "none ",
                }}
                renderValue={handleRenderValue}
                value={link.platform || "placeholder"}
                onChange={(e) =>
                  handleLinkChange(index, "platform", e.target.value)
                }
              >
                <MenuItem
                  value="placeholder"
                  style={{
                    fontSize: "8px",
                    display: "none",
                  }}
                >
                  Select a Platform
                </MenuItem>
                {socialPlatforms
                  .filter(
                    (platform) => !existingPlatforms.includes(platform.name)
                  )
                  .map((platform) => {
                    return (
                      <MenuItem
                        key={platform.name}
                        style={{ fontSize: "8px" }}
                        value={platform.name}
                      >
                        <img
                          alt="logo"
                          src={platform.icon}
                          style={{
                            height: "12px",
                            width: platform.width,
                            marginLeft: "-7px",
                            marginRight: "3px",
                            marginTop: "-2px",
                          }}
                        />
                        {platform.name}
                      </MenuItem>
                    );
                  })}
              </Select>

              <InputErrorSpan>
                {touched.business_link?.[index]?.platform &&
                errors.business_link?.[index]?.platform
                  ? errors.business_link?.[index]?.platform
                  : ""}
              </InputErrorSpan>
            </div>
          </FormControl>

          <TextField
            variant="outlined"
            className="noBorder"
            value={link.link}
            name={`business_link.${index}.link`}
            onBlur={handleBlur}
            onChange={(e) => handleLinkChange(index, "link", e.target.value)}
            placeholder="Add Link here"
            fullWidth
            InputProps={{
              style: {
                fontSize: "8px",
                height: "20px",
                backgroundColor: "#F6F7F9",
              },
              inputProps: {
                style: {
                  fontSize: "8px",
                  paddingLeft: "8px",
                },
              },
            }}
          />
          {errors.business_link?.[index]?.link ? (
            <img
              src={ASSETS.linkError}
              alt="cross"
              style={{ height: "13px", width: "13px" }}
            />
          ) : (
            <img
              src={ASSETS.linkSuccess}
              alt="cross"
              style={{ height: "13px", width: "13px" }}
            />
          )}
          <CloseIcon
            style={{ width: 12, height: 12, cursor: "pointer" }}
            onClick={() => remove(index)}
          />
        </div>
      ))}
    </div>
  );
};

export default AddLinksForm;
